import { useTypedParams } from '@sorare/routing';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';

import { CollectionLayout as CollectionLayoutComponent } from '#src/components/collections/CollectionLayout/index.tsx';

import type { LayoutParams } from './__generated__/routeParams.ts';

const CollectionLayout = () => {
  const { currentUser } = useCurrentUserContext();
  const { collectionSlug } = useTypedParams<LayoutParams>();

  if (!currentUser) {
    return null;
  }

  return (
    <CollectionLayoutComponent
      collection={collectionSlug}
      userSlug={currentUser.slug}
    />
  );
};

export default CollectionLayout;
